chat:
  message:
    character-name:
      airi: AIRI
      core-system: Core система
      you: Ты
message: Спроси что-нибудь
operations:
  load-models: Загрузить модели
  load-models-status:
    loading: Загружается...
    ready: Готово!
select-a-audio-input: Выберите аудио вход
select-a-model: Выберите модель
select-a-voice: Выберите голос
viewers:
  debug-menu:
    emotions: Эмоции
    emotions-btn:
      angry: '😠 Злость'
      awkward: '😳 Неловкость'
      happy: '😄 Радость'
      neutral: '🙂 Нейтраль'
      question: '🤔 Вопрос'
      sad: '😫 Грусть'
      surprised: '🤯 Удивление'
      think: '🤨 Задумчивость'
    vrm:
      camera: Камера
      model:
        title: Модель
waiting: Ожидание
